<div class="container-fluid box-detail px-0 py-0 mx-0 my-0">
  <mat-dialog-actions>
    <button class="btn close" type="button" mat-dialog-close></button>
  </mat-dialog-actions>
  <div class="page-content px-0 py-0">
    <div class="row box-info pd-top">
      <div class="col-md-12">
        <p class="fs-20"><b>{{'Regulatory Filing' | translate}}</b></p>
      </div>
    </div>
    <hr>
    <div class="row box-info" [formGroup]="form">
      <div [class]="checkShowRequestBtn() ? 'col-md-4' : 'col-md-5'">
        <div class="form-group">
          <label class="blue-color required">{{'UEN' | translate}}</label>
          <input maxLen len="17" formControlName="uen" type="text" class="form-control"
            [ngClass]="{ 'is-invalid': (uen.touched || uen.dirty) && uen.invalid }" />
        </div>
      </div>
      <div [class]="checkShowRequestBtn() ? 'col-md-4' : 'col-md-5'">
        <div class="form-group">
          <label class="blue-color required">{{'Tradeweb ID' | translate}}</label>
          <input maxLen len="17" formControlName="tradeweb_id" type="text" class="form-control"
            [ngClass]="{ 'is-invalid': (tradeweb_id.touched || tradeweb_id.dirty) && tradeweb_id.invalid }" />
        </div>
      </div>
      <div class="col-md-2 form-group">
        <button class="btn btn-secondary btn-block mt-18" mat-dialog-close>
          {{ 'Cancel' | translate }}
        </button>
      </div>
      <div *ngIf="checkShowRequestBtn()" class="col-md-2 form-group">
        <button [disabled]="form.invalid" (click)="form.valid && submitRequest()" class="btn btn-secondary btn-block mt-18">
          {{ 'Request' | translate }}
        </button>
      </div>
    </div>

    <div class="list-content">
      <h2>{{ 'Request list' | translate }}</h2>
      <div class="data-table scrollbar-custom list-container">
        <div class="table-container" style="height: 260px">
          <table mat-table [dataSource]="requests" matSort (matSortChange)="sortRequests($event)">
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'Req No.' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.id }}
              </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'Req Date' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.request_date | date: 'dd/MM/yy' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="uen">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'UEN' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.uen }}
              </td>
            </ng-container>
            <ng-container matColumnDef="tradeweb_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'Tradeweb ID' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.tradeweb_id }}
              </td>
            </ng-container>
            <ng-container matColumnDef="from">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'From Date' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.start_date | date: 'dd/MM/yy' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="to">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'To Date' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.end_date | date: 'dd/MM/yy' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'Status' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.status_name }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColRequest; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColRequest"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell-no-data" colSpan="7">{{ 'No data' | translate}}</td>
            </tr>
          </table>
        </div>
        <mat-paginator [length]="reqTotal" [pageIndex]="reqPageOffset / reqPageSize" [pageSize]="reqPageSize"
          [pageSizeOptions]="[5, 10, 20]" (page)="pageChangeRequest($event)" showFirstLastButtons></mat-paginator>
      </div>
    </div>

    <div class="list-content">
      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h2 style="margin-bottom: unset;">{{ 'Status history' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="data-table scrollbar-custom list-container">
          <div class="table-container" [style.height]="historiesTotal > historiesPageSize ? '385px' : 'unset'">
            <table mat-table [dataSource]="histories" matSort (matSortChange)="sortHistories($event)">
              <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Req No.' | translate }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element?.request_no }}
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'Requested date' | translate }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element?.history_info?.request_date | date: 'dd/MM/yy' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="update">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'Updated date' | translate }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element?.created_date | date: 'dd/MM/yy' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'Status' | translate }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element?.history_info?.status_name }}
                </td>
              </ng-container>
              <ng-container matColumnDef="comment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'Comment' | translate }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="text-truncate"
                  [matTooltip]="element?.comment?.length > 120 ? element?.comment : ''"
                >
                  {{ element?.comment }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayColHistories; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayColHistories"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell-no-data" colSpan="5">{{ 'No data' | translate}}</td>
              </tr>
            </table>
          </div>
          <mat-paginator *ngIf="historiesTotal > historiesPageSize"
            [length]="historiesTotal" [pageIndex]="historiesPageOffset / historiesPageSize" [pageSize]="historiesPageSize"
            [pageSizeOptions]="[10, 20, 50]" (page)="pageChangeHistories($event)" showFirstLastButtons></mat-paginator>
        </div>
      </mat-expansion-panel>
    </div>

  </div>
</div>
